






























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Testimonial extends Vue {
  
  @Prop({ type: String }) primaryQuote!: string
  @Prop({ type: String }) secondaryQuote?: string
  @Prop({ type: String }) authorName?: string
  @Prop({ type: String }) authorTitle?: string
  @Prop({ type: String }) authorImageSrc?: string
  @Prop({ type: String }) imageSrc?: string
  @Prop({ type: String }) color?: string

}
